import { useFetch } from '../../../hooks/useFetch';
import { WorkScale } from '../../../models/work-scale';
import { errorNotification } from '../../../providers/mantine-notifications';
import { translateServerHttpErrors } from '../../../utils/helpers';
import {
  UseCreateWorkScaleProps,
  UseGetWorkScaleProps,
  UseShowWorkScaleProps,
} from '../../../utils/types/data/hooks/work-scale';
import {
  createWorkScaleRequest,
  getWorkScaleRequest,
  showWorkScale,
} from '../../work-scale';

export function useGetWorkScaleList() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<WorkScale[]>();

  const fetch = ({ query }: UseGetWorkScaleProps) =>
    fetchData({
      fetcher: () => getWorkScaleRequest(query),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao buscar escalas.',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}

export function useGetWorkScale() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<WorkScale>();

  const fetch = ({ id, onSuccess }: UseShowWorkScaleProps) =>
    fetchData({
      fetcher: () => showWorkScale(id),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao buscar escala.',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}

export function useCreateWorkScale() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<WorkScale>();

  const fetch = ({ data, onSuccess }: UseCreateWorkScaleProps) =>
    fetchData({
      fetcher: () => createWorkScaleRequest(data),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao criar escala.',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}
